import * as React from "react";

import { Box, Typography } from "@material-ui/core";

import {
  useOnboardingStatusContext,
  useRunOnce,
  useTranslation,
} from "client/hooks";
import { logAmplitudeEvent } from "client/lib/amplitude";

import { StatusLabel } from "../StatusLabel";
import { StatusStep } from "../StatusStep";
import { useStyles } from "../styles";
import type {
  CashPayOnboardingStatusToCurrentStateMap,
  StatusMap,
} from "../types";

const onboardingStatusToCurrentStateMap: CashPayOnboardingStatusToCurrentStateMap = {
  NONE: "None",
  IN_PROGRESS: "None",
  READY_TO_INSTALL: "Reviewing",
};

export const CashPayProfileStatusStep: React.FC<{
  merchantId: string;
}> = ({ merchantId }) => {
  const t = useTranslation();
  const classes = useStyles();
  const { cashPayOnboardingStatus } = useOnboardingStatusContext();
  const currentState =
    onboardingStatusToCurrentStateMap[cashPayOnboardingStatus ?? "NONE"];

  const statusMap: StatusMap = {
    None: {},
    InProgress: {},
    Done: {
      className: classes.dark,
    },
    Paused: {},
    Reviewing: {
      className: classes.dark,
    },
    RequiresAttention: {},
    Declined: {},
  };

  const { className } = statusMap[currentState];

  useRunOnce(() =>
    logAmplitudeEvent("CASH_STATUS_PAGE", "cash_profile_status_card_loaded", {
      merchantId: merchantId,
    })
  );

  return (
    <StatusStep timeToFade={500} activeOnboardingStep="CashPayProfileStatus">
      <Box className={`${className} ${classes.statusWrapper}`} mb={2} p={2}>
        <Box alignItems="center" display="flex" justifyContent="space-between">
          <Typography variant="h6">
            <strong>{t("uiCashPayProfileStatus")}</strong>
          </Typography>
          <StatusLabel status={currentState} />
        </Box>
      </Box>
    </StatusStep>
  );
};
